<template>
  <v-app>
    <div id="createBusinessLocationContainer">
      <create-business-location-component
          :isUpdateMode="false"
      >
      </create-business-location-component>
    </div>
  </v-app>
</template>

<script>
import CreateBusinessLocationComponent from "../../../components/b2b/hyundai/CreateBusinessLocationComponent";
export default {
  name: "hyundaiCreateBusinessLocation",
  components: {CreateBusinessLocationComponent},
  mounted() {
    setTimeout(() => {
      let el = document.getElementsByClassName('v-application--wrap')[0];

      // alert(el.offsetHeight)

      el.style.setProperty('min-height', `${el.offsetHeight - 50}px`);

    },0);

  }
}
</script>

<style scoped>
#createBusinessLocationContainer {
  background: #D2D2D2;
  font-family: HDharmony, sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100%);
}


</style>
